import React from 'react'
import { Route } from 'react-router'
import LayoutUnauthorized from './layout-unauthorized'
import { routes as UserRoutes } from './user'

const Routes = (
  <Route>
    <Route component={LayoutUnauthorized}>{UserRoutes}</Route>
  </Route>
)

export default Routes
